import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Lifecycle } from '../../../../_helpers/Lifecycle/Lifecycle.class';
import { $DBManagerService } from '../../../../_helpers/DB/DBManager.service';
import { $BroadcastManagerService } from '../../../../_helpers/BroadcastManager.service';
import { APIObserverService } from '../../../Trai_module/_observerServices/API-Observer';
import { ChartOptions, ChartType, ChartDataSets } from 'chart.js';
import { Label } from 'ng2-charts';
import * as moment from 'moment-timezone';
import { formatDate } from '@angular/common';

const now = new Date();
const currentdat = formatDate(now, 'dd-MM-yyyy', 'en-US', '+0530');
const mydate = moment(now, 'DD-MM-YYYY').unix() - ( 30 * 86400 )
let lastMonthDate = moment.unix(mydate).tz('Asia/Kolkata').format('DD-MM-YYYY');

console.log("current date and last motbhs date:",lastMonthDate,currentdat)

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {
  ComCount: any;
  entityCount: any;
  tmCount: any;
  headerCount: any;
  CTCount: any;
  prefCount: any;
  CSCount: any;
  reportcount: any;
  resolvecount: any;
  tapcount: any;
  oapcount: any;


  public barChartOptions: any = {
    scaleShowVerticalLines: false,
    responsive: true,
    maintainAspectRatio: false,
	 scales: {
      yAxes: [{
        scaleLabel: {
            display: true,
            labelString: 'Complaints'
         },
        ticks: {
          beginAtZero: true,
          callback: function(value) {if (value % 1 === 0) {return value;}}
        }
      }]
    }
  };
  public barChartLabels: string[];
  public barChartType: string = 'bar';
  public barChartLegend: boolean = true;

  public barChartData: any[] = [
    { data: [], label: 'Complaints' }];
    public chartColors: Array<any> = [
    { // first color
      backgroundColor: '#f56d23',
      borderColor: 'rgba(225,10,24,0.2)',
      pointBackgroundColor: 'rgba(225,10,24,0.2)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(225,10,24,0.2)'
    },
    { // second color
      backgroundColor: 'rgba(225,10,24,0.2)',
      borderColor: 'rgba(225,10,24,0.2)',
      pointBackgroundColor: 'rgba(225,10,24,0.2)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(225,10,24,0.2)'
    }];

  constructor(
    private db: $DBManagerService,
    private evt: $BroadcastManagerService,
    private Os: APIObserverService
  ) {

    this.evt.emit({ 'click': 'HEADER_EVENT' });
  }
  ngOnInit() {
let data ={
  "Start_Date" : lastMonthDate,
  "End_Date" : currentdat
}
    this.Os.getGraph(data).subscribe(data => {
      console.log( Object.keys(data))
      this.barChartLabels = Object.keys(data);
      this.barChartLabels.forEach(label => {
        console.log(label)
        this.barChartData[0].data.push(data[label]['count']);
      });
    });;
      this.getCount()
    

  }
  getCount() {
    this.Os.getEntitycount().subscribe(result => {
      console.log(result)
      this.entityCount = result.recordcount;
    })
    this.Os.getTeleMarketercount().subscribe(result => {
      console.log("tm count", result)
      this.tmCount = result.recordcount;
    })
    this.Os.getHeadercount().subscribe(result => {
      console.log(result)
      this.headerCount = result.recordcount;
    })
   
      setTimeout(()=>{
        this.Os.getContentTemplatecount().subscribe(result => {
				console.log(result)
      this.CTCount = result.recordcount;
    })
  },30000)
    this.Os.getConsentcount().subscribe(result => {
      console.log(result)
      this.CSCount = result.recordcount;
    })
    this.Os.getPreferencecount().subscribe(result => {
      console.log(result)
      this.prefCount = result.recordcount;
    })
    this.Os.getComplaintcount().subscribe(result => {
      console.log(result)
      this.ComCount = result.recordcount;
      this.reportcount = result.reportcount;
      this.resolvecount = result.resolvecount;
      this.tapcount = result.tapcount;
      this.oapcount = result.oapcount;

    })

  }

  _destroy(): void {
    // throw new Error("Method no implemented.");
  }

}
